import React, { useContext,  } from 'react';
// import { FaArrowRightLong } from "react-icons/fa6";
import { FormContext } from '../Provider';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

export default function EditAcadmic({ step, setStep }) {
    console.log("step:", step, "setStep:", setStep); // Debug line
    const navigate = useNavigate()
    const { editPersonal, setEditPersonal } = useContext(FormContext);
    // const api = process.env.REACT_APP_URL;

    let { id } = useParams();
    console.log("Student id", id); // Debug line


    // Revoke object URL on cleanup
    const validationCheck = () => {

        navigate(`/admin-forms/${id}`)
        setStep(step + 1);

    }


    return (
        <div className=" pt-3">
            <div className="bg-white  p-7">
                <div className=" bg-gray-100 px-4  container py-5 h-100 flex justify-center items-start">
                    <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-4xl">
                        <div className="font-bold text-lg text-primary-800">Academic Details</div>


                        <div className="flex flex-col gap-6 mt-6">
                            {/* First Row: Institute & Department */}
                            <div className="flex flex-col md:flex-row gap-6">
                                {/* Institute */}
                                <div className="relative w-full md:w-1/2">
                                    <input
                                        type="text"
                                        id="institute"
                                        placeholder=" "
                                        className="peer h-14 w-10/12 px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={editPersonal.academicDetails.instituteName}
                                        onChange={(e) => {
                                            setEditPersonal({
                                                ...editPersonal,
                                                academicDetails: {
                                                    ...editPersonal.academicDetails,
                                                    instituteName: e.target.value
                                                }
                                            });

                                        }}
                                    />
                                    <label
                                        htmlFor="institute"
                                        className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.5rem] scale-75  peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[3rem] peer-focus:scale-75 peer-focus:text-blue-600"
                                    >
                                        Institute Name
                                    </label>

                                </div>

                                {/* Department */}
                                <div className="relative w-full md:w-1/2">
                                    <input
                                        type="text"
                                        id="course"
                                        placeholder=" "
                                        className="peer h-14 w-10/12 px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={editPersonal.academicDetails.courseName}
                                        onChange={(e) => {
                                            setEditPersonal({
                                                ...editPersonal,
                                                academicDetails: {
                                                    ...editPersonal.academicDetails,
                                                    courseName: e.target.value
                                                }
                                            });

                                        }}
                                    />
                                    <label
                                        htmlFor="course"
                                        className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.5rem] scale-75  peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2  peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[3rem] peer-focus:scale-75  peer-focus:text-blue-600"
                                    >
                                        Course Name
                                    </label>

                                </div>

                            </div>

                            {/* Second Row: Course & Year */}
                            <div className="flex flex-col md:flex-row gap-6">
                                {/* Course */}

                                <div className="relative w-full md:w-1/2">
                                    <input
                                        type="text"
                                        id="dept"
                                        placeholder=" "
                                        className="peer h-14 w-10/12 px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={editPersonal.academicDetails.deptName}
                                        onChange={(e) => {
                                            setEditPersonal({
                                                ...editPersonal,
                                                academicDetails: {
                                                    ...editPersonal.academicDetails,
                                                    deptName: e.target.value
                                                }
                                            });

                                        }}
                                    />
                                    <label
                                        htmlFor="dept"
                                        className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.5rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2  peer-placeholder-shown:scale-100 peer-focus:top-1/2   peer-focus:-translate-y-[3rem] peer-focus:scale-75  peer-focus:text-blue-600"
                                    >
                                        Department Name
                                    </label>

                                </div>

                                {/* Year */}
                                <div className="relative w-full  md:w-1/2">
                                    <input
                                        type="Number"
                                        id="passout"
                                        placeholder=" "
                                        className="peer h-14 w-10/12 px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        value={editPersonal.academicDetails.passout}
                                        onChange={(e) => {
                                            setEditPersonal({
                                                ...editPersonal,
                                                academicDetails: {
                                                    ...editPersonal.academicDetails,
                                                    passout: e.target.value
                                                }
                                            });

                                        }}
                                    />
                                    <label
                                        htmlFor="passout"
                                        className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.5rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[3rem] peer-focus:scale-75  peer-focus:text-blue-600"
                                    >
                                        Year of Passout
                                    </label>

                                </div>
                            </div>

                            {/* Currently Studying Checkbox */}

                            {/* Location */}
                            <div className="relative w-full md:w-1/2">
                                <input
                                    type="text"
                                    id="location"
                                    placeholder=" "
                                    className="peer h-14 w-full px-4 pt-6 pb-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    value={editPersonal.academicDetails.location}
                                    onChange={(e) => {
                                        setEditPersonal({
                                            ...editPersonal,
                                            academicDetails: {
                                                ...editPersonal.academicDetails,
                                                location: e.target.value
                                            }
                                        });

                                    }}
                                />
                                <label
                                    htmlFor="location"
                                    className="absolute left-4 px-1 bg-white text-base font-medium text-gray-500 transition-all duration-300 transform top-1/2 -translate-y-[2.6rem] scale-75 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-1/2 peer-focus:-translate-y-[2.6rem] peer-focus:scale-75  peer-focus:text-blue-600"
                                >
                                    Location
                                </label>

                            </div>

                            {/* Buttons */}
                            <div className="flex flex-row sm:flex-row justify-between items-center gap-4 mt-6">
                                <button
                                    className="flex items-center gap-2 bg-primary-800 hover:bg-primary-700 text-white font-medium py-2 px-6 rounded"
                                    onClick={() => {
                                        // navigate(`/admin-forms/${id}`)
                                        setStep(step - 1)
                                    }}
                                >
                                    {/* <FaArrowLeftLong /> */}
                                    Back
                                </button>

                                <button
                                    className="flex items-center gap-2 bg-primary-800 hover:bg-primary-700 text-white font-medium py-2 px-6 rounded"
                                    onClick={validationCheck}
                                >
                                    Next
                                    {/* <FaArrowRightLong /> */}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
